<template>
  <div
    v-if="validationError && validationError.message"
    class="tei-error comet-form--error"
  >
    <span
      class="comet-form__field-error"
      role="alert"
    >
      <NebulaIcon
        class-override="comet-form__field-error-icon"
        symbol-id="message-error"
      />
      <span class="comet-form__field-error-text">
        {{ validationError.message }}
      </span>
    </span>
  </div>
</template>

<script>
import { NebulaIcon } from '@discoveryedu/nebula-components';

export default {
  name: 'TEIError',
  components: {
    NebulaIcon,
  },
  props: {
    validationError: {
      type: [Error, Boolean],
      default: false,
    },
  },
};
</script>
